export default "__VITE_ASSET__9bErPIRs__"